import { motion } from "framer-motion";

const provinces = [
  { name: "Gauteng", cities: "Johannesburg · Pretoria · Fourways" },
  { name: "Western Cape", cities: "Cape Town · Stellenbosch" },
  { name: "KwaZulu-Natal", cities: "Durban · uMhlanga" },
  { name: "Eastern Cape", cities: "Gqeberha · East London" },
];

export const Coverage = () => {
  return (
    <section
      id="coverage"
      className="relative py-24 md:py-32 bg-[#0D1C13] text-cream"
      data-testid="coverage-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-6">
            <div className="uppercase text-xs tracking-[0.3em] text-gold mb-6">
              Where we operate
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight">
              SA-wide coverage,
              <br />
              <span className="italic text-gold">local</span> presence.
            </h2>
          </div>
          <div className="lg:col-span-5 lg:col-start-8 flex items-end">
            <p className="text-cream/75 text-base md:text-lg leading-relaxed">
              Our primary operational regions span four major provinces, with
              extended coverage available nationwide for managing agents and
              multi-site portfolios.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-cream/10">
          {provinces.map((p, i) => (
            <motion.div
              key={p.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="bg-[#0D1C13] p-8 md:p-10 hover:bg-forest transition-colors duration-500"
              data-testid={`coverage-card-${i}`}
            >
              <div className="font-serif text-5xl text-gold/40 leading-none mb-6">
                0{i + 1}
              </div>
              <h3 className="font-serif text-3xl text-cream mb-2">{p.name}</h3>
              <p className="text-cream/60 text-sm tracking-wide">{p.cities}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Coverage;
